export const getStoreId = (): string => {
  switch (process.env.NEXT_PUBLIC_SITE_ID_ANALYTICS) {
    case 'opopular.d':
      return 'popstore';
    case 'tocantins.d':
      return 'jstostore';
    case 'daqui.d':
      return 'daquistore';
    default:
      return 'popstore';
  }
};